import {
  Stepper,
  StepperIndicator,
  StepperItem,
  StepperTitle,
} from '@azelis/ui/components/stepper';

import { useSubmitWizard } from './submit-wizard-context';

export function SubmitStepper() {
  const { step } = useSubmitWizard();

  return (
    <Stepper
      className="w-full"
      size="sm"
      value={step}
    >
      <StepperItem step={1}>
        <StepperIndicator />
        <StepperTitle>
          Upload
          <br />
          Questionnaire
        </StepperTitle>
      </StepperItem>
      <StepperItem step={2}>
        <StepperIndicator />
        <StepperTitle>Select Documents</StepperTitle>
      </StepperItem>
      <StepperItem step={3}>
        <StepperIndicator />
        <StepperTitle>Upload extra Documents</StepperTitle>
      </StepperItem>
      <StepperItem step={4}>
        <StepperIndicator />
        <StepperTitle>Finish</StepperTitle>
      </StepperItem>
    </Stepper>
  );
}
